export function invitationPageContentClassName({
  showPendingModelInvitePanel,
  showRolePanel,
}: {
  showPendingModelInvitePanel: boolean;
  showRolePanel: boolean;
}) {
  if (showPendingModelInvitePanel) {
    return 'page-container max-w-[960px]';
  }

  if (showRolePanel) {
    return 'page-container grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,680px)_340px] lg:gap-x-6 items-start';
  }

  return 'page-container max-w-[680px]';
}

export function invitationPageRolePanelClassName() {
  return 'mt-6 bg-panel border border-line rounded-[18px] shadow-md p-5 lg:sticky lg:top-[92px] lg:mt-0 space-y-5 lg:order-none';
}
